import { render } from "./Or_tableClaimNum.vue?vue&type=template&id=02861dbd&scoped=true&ts=true"
import script from "./Or_tableClaimNum.vue?vue&type=script&lang=ts"
export * from "./Or_tableClaimNum.vue?vue&type=script&lang=ts"

import "./Or_tableClaimNum.vue?vue&type=style&index=0&id=02861dbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02861dbd"]])

export default __exports__